// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2p3Zo","header":"PatientBlock_header__13gwa","label":"PatientBlock_label__ko1Hw","option":"PatientBlock_option__2ymoa"};